import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { has } from 'lodash';
import cx from 'classnames';

import { optionPropTypes } from 'sharedParts/config/blockConfig/settings/optionListPropTypes';

import MatrixCell from '../../layout/MatrixCell';
import MatrixInputGroup from '../MatrixInputGroup';
import getLabel from '../../utils/getLabel';
import propTypeBlockStyling from '../../../../../../domains/styling/config/editorBlock/PropTypes/blockStyling';

import styles from './MatrixCheckableInputGroup.scss';

export default class MatrixCheckableInputGroup extends Component {
  static propTypes = {
    option: optionPropTypes,
    value: PropTypes.object,
    meta: PropTypes.object.isRequired,
    labelList: PropTypes.array.isRequired,
    inputCellRenderer: PropTypes.func.isRequired,
    handleChange: PropTypes.func.isRequired,
    form: PropTypes.string.isRequired,
    styling: propTypeBlockStyling,
  };

  render() {
    const {
      value,
      meta,
      option,
      labelList,
      handleChange,
      inputCellRenderer,
      form,
      styling: { selectionColor },
      styling,
    } = this.props;

    return (
      <MatrixInputGroup
        form={form}
        meta={meta}
        option={option}
        styling={styling}
      >
        {Array.from(labelList, label => (
          <MatrixCell
            normalCheckedColor={selectionColor}
            multiline
            hasInput
            key={label.id}
            className={cx(styles.item, styles.up)}
            cellRenderer={inputCellRenderer}
            onChange={handleChange(label)}
            checked={has(value, label.id)}
            label={getLabel(label.value)}
          />
        ))}
      </MatrixInputGroup>
    );
  }
}
